function initGoogleReviews() {
    const service = new google.maps.places.PlacesService(document.createElement('div'));
    const starSvg = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE0OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDIwIDIwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cG9seWdvbiBmaWxsPSIjZmNjNzM3IiBwb2ludHM9IjEwLDAgMTMuMDksNi41ODMgMjAsNy42MzkgMTUsMTIuNzY0IDE2LjE4LDIwIDEwLDE2LjU4MyAzLjgyLDIwIDUsMTIuNzY0IDAsNy42MzkgNi45MSw2LjU4MyAiLz48L3N2Zz4=";
  
    service.getDetails({
      placeId: 'ChIJi3mAcMjazRIRAjR60396UQI',
      fields: ['reviews'],
      reviewsSort: 'newest'
    }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK && place.reviews) {
        const container = document.getElementById('google-reviews-dynamic');
        container.innerHTML = ''; 
        place.reviews.forEach(review => {
            if (review.rating >= 3) {
                let starsHtml = '';
                for (let i = 0; i < review.rating; i++) {
                    starsHtml += `<img src="${starSvg}" width="15" height="15" alt="Étoile"> `;
                }
                const reviewHtml = `
                    <div class="google-review">
                    <img src="${review.profile_photo_url}" class="author-img" width="64" height="64" alt="${review.author_name}" referrerpolicy="no-referrer">
                    <div>
                        <a href="${review.author_url}" class="author-name" target="_blank">${review.author_name}</a>
                        <p class="stars" aria-label="${review.rating} stars"><span class="star-rating">${starsHtml}</span></p>
                        <p class="review">${review.text}</p>
                    </div>
                    </div>`;
                container.innerHTML += reviewHtml;
            }
        });
      }
    });
  }
  window.addEventListener('load', initGoogleReviews);